import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
export function ProtectedRoute({ roles }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (_jsx("div", { className: "flex min-h-screen items-center justify-center text-slate-500", children: "Loading\u2026" }));
    }
    if (!user) {
        return _jsx(Navigate, { to: "/welcome", replace: true, state: { from: location } });
    }
    if (user.status === "pending") {
        return _jsx(Navigate, { to: "/pending", replace: true });
    }
    if (user.status === "rejected") {
        return _jsx(Navigate, { to: "/welcome", replace: true });
    }
    if (roles && !roles.includes(user.role)) {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    return _jsx(Outlet, {});
}
